var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAttach(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.0449 20.519L22.4068 28.5525C22.0583 29.1345 21.495 29.5563 20.8384 29.7267C20.1817 29.8971 19.4844 29.8025 18.8969 29.4633C18.3094 29.1241 17.8788 28.5675 17.698 27.9136C17.5173 27.2597 17.6008 26.561 17.9307 25.9682L24.0028 15.4342C24.2866 14.9286 24.668 14.4844 25.1247 14.1272C25.5815 13.7701 26.1046 13.5072 26.6637 13.3537C27.2229 13.2002 27.8069 13.1593 28.382 13.2332C28.9571 13.3072 29.5118 13.4945 30.0139 13.7844C30.516 14.0743 30.9556 14.461 31.3072 14.9221C31.6588 15.3832 31.9153 15.9094 32.062 16.4704C32.2086 17.0313 32.2425 17.6158 32.1616 18.19C32.0807 18.7641 31.8866 19.3165 31.5906 19.8151L25.4703 30.4158C25.0724 31.1285 24.5368 31.7551 23.8946 32.2591C23.2524 32.763 22.5165 33.1342 21.7295 33.3512C20.9426 33.5682 20.1203 33.6266 19.3106 33.5229C18.5009 33.4193 17.7199 33.1558 17.013 32.7476C16.306 32.3395 15.6872 31.7948 15.1927 31.1454C14.6981 30.496 14.3375 29.7547 14.1319 28.9647C13.9264 28.1747 13.8799 27.3517 13.9952 26.5436C14.1105 25.7355 14.3854 24.9584 14.8037 24.2574L20.5229 14.3514",
    stroke: "#6D7B75",
    strokeWidth: 1.42271,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttach);
export default __webpack_public_path__ + "static/media/attach.0ce7efe290952b6cb83ef600a360948a.svg";
export { ForwardRef as ReactComponent };